import { render, staticRenderFns } from "./RoomMessageReply.vue?vue&type=template&id=86b41b08&"
import script from "./RoomMessageReply.vue?vue&type=script&lang=js&"
export * from "./RoomMessageReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports